export const DEFAULT_LINE_SPEED = 30;
